module.exports = __webpack_public_path__ + "img/375.40acc68c.jpg";